/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: dropdown-service.ts
 *
 * Created by kyang on 2019-11-06.
 */

function DropdownServiceConstructor (
    this: JS5Object,
    _: JS5Object,
) {

    //=========//
    // Utility //
    //=========//

    // In many cases, the items in a dropdown's collection
    // aren't the same as the selected object.
    // For example:
    //     - Collection is a list of items, returned from the server
    //     - Selected item is a property of a different object, returned from the server
    //
    // This function detects those cases, and resolves it.
    this.areItemsEqual = (dropdown: JS5Object, itemA: any, itemB: any) => {
        // TODO: Handle duplicates via modelProp?
        return itemA === itemB;
    };

    // This function also works on redundant copies of items.
    // See areItemsEqual() for more information.
    this.getItemIndex = (dropdown: JS5Object, array: any[], item: any) => {
        // TODO: Check can handle duplicates
        return _.findIndex(array, (searchItem: any) => {
            return this.areItemsEqual(dropdown, searchItem, item);
        });
    };


    //==================//
    // Property Parsing //
    //==================//

    this.getPrompt = (dropdown: JS5Object) => {
        return String(dropdown.prompt);
    };

    this.getLabel = (dropdown: JS5Object, item: any) => {
        let labelValue: any;
        if (_.isFunction(dropdown.labelFunction)) {
            labelValue = dropdown.labelFunction(item, dropdown.labelPath);
        } else if (dropdown.labelPath) {
            labelValue = _.get(item, dropdown.labelPath);
        } else {
            labelValue = item;
        }
        return String(labelValue);
    };

    this.isItemDisabled = (dropdown: JS5Object, item: any) => {
        if (_.size(dropdown.itemDisablePath) < 1) {
            return false;
        }
        return _.get(item, dropdown.itemDisablePath);
    };


    //================//
    // List Searching //
    //================//

    // Returns true if the filter was modified, false if it wasn't
    this.tryUpdateFilter = (dropdown: JS5Object, keyEvent: JS5Object) => {
        let filterModified = false;
        if (keyEvent.key.length === 1) {
            dropdown.filter += keyEvent.key;
            filterModified = true;
        } else if (keyEvent.key === 'Backspace' || keyEvent.key === 'Delete') {
            dropdown.filter = dropdown.filter.substring(0, dropdown.filter.length - 1);
            filterModified = true;
        } else if (keyEvent.key === 'Clear') {
            dropdown.filter = '';
            filterModified = true;
        }

        return filterModified;
    };

}

angular
    .module('prism-ui.components')
    .service(
        'DropdownService',
        DropdownServiceConstructor
    );
